import { create } from 'zustand';
import { fetchDonations } from '../api';
import { useErrorStore } from './useErrorStore';

export interface Donation {
  id: number;
  donorID: number;
  date: string;
  amount: number;
  paymentMethod: string;
  name: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  pan: string;
  gift: string;
  purpose: string;
  head: string;
  event: string;
  taxReceiptNo: string;
  email: string;
  txnRefId: string;
  refBy: number | string;
  subPurpose: string;
  cartId: string;
  cartItemCount: number;
  cartItems: Array<{
    id: number;
    donationId: number;
    cartId: string;
    itemId: string;
    name: string;
    amount: number;
    quantity: number;
    pagePath: string;
    lineTotal: number;
    createdAt: string;
  }>;
  platform: string; // Added platform field
  status: string; // Added status field
}

interface DonationsState {
  donations: Donation[];
  loading: boolean;
  refresh: () => Promise<void>;
}

export const useDonationsStore = create<DonationsState>((set) => ({
  donations: [],
  loading: false,
  refresh: async () => {
    set({ loading: true });
    try {
      const data = await fetchDonations();
      set({ donations: Array.isArray(data) ? data : [], loading: false });
    } catch (error) {
      useErrorStore.getState().setError('Failed to fetch donations.');
      set({ loading: false });
    }
  },
}));
